import { Add, EmptyWorkflow } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import { DashedBorder } from "@/components/ui/dashed-border";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  tPrefix: string;
  onButtonClick?: () => void;
}

const EmptyQuestionnaire: React.FC<Props> = ({ tPrefix, onButtonClick }) => {
  const { t } = useTranslation();

  return (
    <DashedBorder className="flex flex-col items-center justify-center w-full h-[17.5rem] px-20 rounded-2xl gap-10">
      <div className="flex flex-col items-center">
        <EmptyWorkflow />
        <Text variant="bodySecondary">
          {t(`${tPrefix}.emptyWorkflows.subtitle`)}
        </Text>
      </div>
      <Button className="w-fit" onClick={onButtonClick}>
        <IconContainer size="5" color="current">
          <Add />
        </IconContainer>
        {t(`${tPrefix}.emptyWorkflows.addButton`)}
      </Button>
    </DashedBorder>
  );
};

export default EmptyQuestionnaire;
